module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row profile-dashboard-wrapper border-bottom white-bg dashboard-header"
  }, [_c('div', {
    staticClass: "col-lg-4 col-xl-3"
  }, [_c('h2', [_vm._v("\n        Profiles Dashboard\n        "), (!_vm.loadingPlugins) ? _c('span', {
    staticClass: "badge badge-primary"
  }, [_vm._v(_vm._s(_vm.upperCase(_vm.mode)))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [(!_vm.loadingPlugins) ? _c('profiles-charts', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mode === 'pro'),
      expression: "mode === 'pro'"
    }],
    attrs: {
      "id": "dashboard-charts",
      "loading": _vm.loadingCharts,
      "data": _vm.charts
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(!_vm.loadingPlugins) ? _c('profiles-data-filter', {
    attrs: {
      "loading-profiles": _vm.loadingProfiles,
      "loading-saved-queries": _vm.loadingSavedQueries,
      "loading": _vm.loadingFilters,
      "searching": _vm.searching,
      "filters": _vm.filters,
      "results": _vm.results,
      "savedQueries": _vm.savedQueries,
      "mode": _vm.mode
    },
    on: {
      "filter": function($event) {
        return _vm.$emit('filter', $event)
      },
      "download": function($event) {
        return _vm.$emit('download', $event)
      },
      "display-profiles": function($event) {
        return _vm.$emit('display-profiles')
      },
      "load-more-profiles": function($event) {
        return _vm.$emit('load-more-profiles')
      },
      "save-query": function($event) {
        return _vm.$emit('save-query', $event)
      },
      "delete-query": function($event) {
        return _vm.$emit('delete-query', $event)
      }
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('privacy-data-list', {
    staticClass: "privacy-list",
    attrs: {
      "isloading": _vm.loadingOptins
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8ba18a9e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/profiles/Dashboard.vue
// module id = 3366
// module chunks = 3